import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Bar from './pages/Bar';
import Chat from './pages/Chat';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Profile from './pages/Profile';
import { AuthProvider } from './components/auth/AuthProvider';
import Navbar from './components/layout/Navbar';

function App() {
  return (
    <AuthProvider>
      {/* 🔧 修復:將 Navbar 加入 App 中確保顯示 */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/bar" element={<Bar />} />
        <Route path="/chat/:charId" element={<Chat />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;